/**
 * 판매 버튼 넷(출고 요청 · 세팅 완료 · 출고 · 취소)의 규칙 — 판매 현황 목록과 판매 상세가 같이 쓴다(2026-11-03).
 * 버튼이 보이는 상태는 백엔드 전이표(STATUS_TRANSITIONS sales_order)와 같다. 서버가 마지막에 다시 막는다.
 */
import type { ESalesOrderStatus } from '../../api/client';

export const DISPATCH_REQUESTABLE: readonly ESalesOrderStatus[] = ['preparing'];   // [출고 요청] — 판매 등록에서만
export const SETUP_COMPLETABLE: readonly ESalesOrderStatus[] = ['ordered'];        // [세팅 완료] — 출고 요청에서만
export const DISPATCH_READY: readonly ESalesOrderStatus[] = ['ordered', 'setup_done'];   // [출고] — 파트만 판매는 세팅을 건너뛴다
// 부족(구매 필요)을 보이는 상태 — 진행 중만. 출고 완료 · 취소(일부 출고) · 취소는 남은 부족이 일이 아니다
export const SHORTAGE_STATUSES: readonly ESalesOrderStatus[] = ['preparing', 'ordered', 'setup_done'];
export const CANCELLABLE: readonly ESalesOrderStatus[] = ['preparing', 'ordered', 'setup_done'];

export const DISPATCH_CONFIRM_TEXT = '출고 요청을 보냅니다 — 제품팀의 세팅 · 출고 큐에 들어갑니다.';
export const SETUP_DONE_CONFIRM_TEXT = '묶인 실물이 맞는지 확인했습니다 — 세팅 완료로 옮깁니다.';
export const DISPATCH_UNITS_CONFIRM_TEXT = '묶인 실물을 모두 출고합니다 — 되돌리려면 반품입니다.';

export const CREATE_HREF = '/sales/new';   // 견적 없는 판매 등록(2026-11-02) — 취소 뒤 다시 등록도 이리로

/** 다음 단계 버튼 하나 — 출고 요청 · [세팅 완료 ▾](▾ 안에 "바로 출고") · 출고 중 상태가 허락하는 것(현민 2026-11-04 B — 세팅 완료와 출고가 나란히
 *  크기도 다르게 섞여 있던 것). ▾ 는 <details> 라 화면 상태가 없다 — 바깥을 누르면 closeSplitMenusOutside 가 닫는다.
 *  안의 [바로 출고] 는 [출고] 와 같은 data-action="dispatch"(같은 확인 창). idAttr = 목록은 ' data-id="…"', 상세는 '' */
export function renderStepButton(status: ESalesOrderStatus, idAttr: string, disabled: string): string {
  if (DISPATCH_REQUESTABLE.includes(status)) {
    return `<button type="button" class="btn-primary" data-action="request-dispatch"${idAttr}${disabled}>출고 요청</button>`;
  }
  if (SETUP_COMPLETABLE.includes(status)) {
    return `
      <span class="so-split">
        <button type="button" class="btn-primary" data-action="setup-done"${idAttr}${disabled}>세팅 완료</button>
        <details class="so-split-more"${disabled === '' ? '' : ' inert'}>
          <summary class="btn-primary" aria-label="다른 단계">▾</summary>
          <div class="so-split-menu">
            <button type="button" data-action="dispatch"${idAttr}${disabled}>바로 출고<small>세팅 없이 내보냅니다(파트만 판매 등)</small></button>
          </div>
        </details>
      </span>`;
  }
  if (DISPATCH_READY.includes(status)) {
    return `<button type="button" class="btn-primary" data-action="dispatch"${idAttr}${disabled}>출고</button>`;
  }
  return '';
}

/** 열린 ▾ 메뉴를 닫는다 — 누른 자리가 그 메뉴 밖이면. main.ts 가 문서 클릭에 한 번 건다 */
export function closeSplitMenusOutside(event: MouseEvent): void {
  const target = event.target instanceof Node ? event.target : null;
  document.querySelectorAll<HTMLDetailsElement>('details.so-split-more[open]').forEach((menu) => {
    if (target === null || !menu.contains(target)) menu.open = false;
  });
}

/** 취소 뒤 다시 등록 — 판매 등록 화면이 그 판매의 거래처 · 담당자 · 체크한 품목을 채워 연다 */
export function reregisterHrefOf(saleId: string, itemIds: readonly string[]): string {
  return `${CREATE_HREF}?from=${encodeURIComponent(saleId)}&items=${itemIds.map(encodeURIComponent).join(',')}`;
}
